import React, { useEffect, useRef, useState } from 'react';
import { GripVertical, Plus, Trash2 } from 'lucide-react';
import { useSocket } from '../Context/SocketContext';
import { infoUser } from '../utils/auth';
import Loader from './Loader';

const CATS = [
    { key: 'streaming', label: 'Streaming', nextKey: 'nextStreaming', currentKey: 'currentStreaming', nextJson: 'URL_NEXT_STREAMING', currentJson: 'NEXT_STREAMING' },
    { key: 'sport', label: 'Sport', nextKey: 'nextSport', currentKey: 'currentSport', nextJson: 'URL_NEXT_SPORT', currentJson: 'NEXT_SPORT' },
]

const arr = (v) => Array.isArray(v) ? v : []

const UrlSiteManager = () => {
    const { socket, editJSON, getJSON } = useSocket()
    const userToken = infoUser()

    const [lists, setLists] = useState({ nextStreaming: [], currentStreaming: [], nextSport: [], currentSport: [] })
    const [load, setLoad] = useState(true)
    const [saving, setSaving] = useState(null)
    const drag = useRef(null) // { cat, listKey, index }

    const fetchUrls = () => {
        socket.emit('empire_get_next_url', { token: userToken.expecttoken }, (res) => {
            setLoad(false)
            if (res) {
                setLists({
                    nextStreaming: arr(res.nextStreaming),
                    currentStreaming: arr(res.currentStreaming),
                    nextSport: arr(res.nextSport),
                    currentSport: arr(res.currentSport),
                })
            }
        })
    }

    useEffect(() => { fetchUrls() }, [])

    const updateItem = (key, i, field, value) => {
        setLists(prev => {
            const copy = [...prev[key]]
            copy[i] = { ...copy[i], [field]: value }
            return { ...prev, [key]: copy }
        })
    }
    const removeItem = (key, i) => setLists(prev => ({ ...prev, [key]: prev[key].filter((_, idx) => idx !== i) }))
    const addItem = (key) => setLists(prev => ({ ...prev, [key]: [...prev[key], { url: "", date: "" }] }))

    const onDragStart = (cat, listKey, index) => { drag.current = { cat, listKey, index } }
    const onDropList = (cat, targetKey) => {
        const d = drag.current
        drag.current = null
        if (!d || d.cat !== cat || d.listKey === targetKey) return
        setLists(prev => {
            const item = prev[d.listKey][d.index]
            if (!item) return prev
            if (prev[targetKey].some(x => x.url === item.url)) return prev // pas de doublon
            return {
                ...prev,
                [d.listKey]: prev[d.listKey].filter((_, idx) => idx !== d.index),
                [targetKey]: [...prev[targetKey], item],
            }
        })
    }

    const save = (cat) => {
        setSaving(cat.key)
        editJSON(cat.nextJson, lists[cat.nextKey], () => {
            editJSON(cat.currentJson, lists[cat.currentKey], () => {
                setSaving(null)
                getJSON(socket)
            })
        })
    }

    const renderCol = (cat, title, listKey, accent) => (
        <div className={`url-col ${accent}`} onDragOver={(e) => e.preventDefault()} onDrop={() => onDropList(cat.key, listKey)}>
            <div className='df aic jcsb mb1'>
                <p className='fr cw fs12' style={{ opacity: 0.75 }}>{title}</p>
                <button onClick={() => addItem(listKey)} className='pay-act-btn' title="Ajouter"><Plus size={16} color='#fff' /></button>
            </div>
            {lists[listKey].length === 0 && (
                <p className='fr cw fs12 tac py1' style={{ opacity: 0.35 }}>Glisser ici</p>
            )}
            {lists[listKey].map((it, i) => (
                <div key={i} className='url-item'>
                    <span draggable onDragStart={() => onDragStart(cat.key, listKey, i)} className='url-grip'><GripVertical size={15} color='#8f909c' /></span>
                    <div className='df fdc flex1 gap1'>
                        <input value={it.url || ""} onChange={(e) => updateItem(listKey, i, 'url', e.currentTarget.value)} placeholder='https://...' className='premium-date-input sm' />
                        <input value={it.date || ""} onChange={(e) => updateItem(listKey, i, 'date', e.currentTarget.value)} placeholder='JJ-MM-AAAA' className='premium-date-input sm' />
                    </div>
                    <button onClick={() => removeItem(listKey, i)} className='pay-act-btn' title="Supprimer"><Trash2 size={16} color='#f71717' /></button>
                </div>
            ))}
        </div>
    )

    if (load) {
        return <div className='df aic jcc py2'><Loader /></div>
    }

    return (
        <div className='url-manager df fw gap2 mt2'>
            {CATS.map(cat => (
                <div key={cat.key} className='url-cat'>
                    <div className='df aic jcsb mb2'>
                        <p className='fb cw fs1'>{cat.label}</p>
                        <button onClick={() => save(cat)} disabled={saving === cat.key} className='btn cs df aic jcc'>
                            {saving === cat.key ? <span className='loader sm'></span> : "Enregistrer"}
                        </button>
                    </div>
                    <div className='df gap1 url-cols'>
                        {renderCol(cat, "En attente", cat.nextKey, "")}
                        {renderCol(cat, "Choisi", cat.currentKey, "chosen")}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default UrlSiteManager;
